import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import { sortBy } from 'lodash';
import { hotelSearch } from '../../../../../store/slices/hotel';
import MultiSelectAutocompleteFilter from '../../../../Filters/MultiSelectAutocompleteFilter';
import {
  hotelSearchRequest,
  setHotelTripSearchInputs,
} from '../../../../../store/slices/tripSearch';

const HotelNameFilter = ({ tripId, variant, filterSpacingClass }) => {
  const isHotelTripSearch = !tripId;
  const { searchObj = {} } = useSelector((store) => store.hotel.hotelSearches[tripId] || {});
  const searchStateHotelNames = useSelector((store) =>
    !isHotelTripSearch
      ? (store.hotel.hotelSearches[tripId] || {}).hotelResults
      : store.tripSearch.searchResult && (store.tripSearch.searchResult.filters || {}).hotels,
  );
  const [hotels, setHotels] = useState(null);
  const dispatch = useDispatch();
  const { track } = useAnalytics();
  const hotelTripSearchInputs = useSelector((store) => store.tripSearch.searchInputs.hotel);
  const value = isHotelTripSearch
    ? hotelTripSearchInputs.filterHotelKeys
    : searchObj.filterHotelKeys;

  const handleChange = (newValue) => {
    const payload = {
      tripId,
      searchObj: {
        page: 1,
        filterHotelKeys: newValue,
        hasFilterApplied: true,
      },
    };
    if (isHotelTripSearch) {
      dispatch(setHotelTripSearchInputs({ ...payload.searchObj }));
      dispatch(hotelSearchRequest(payload.searchObj));
    } else {
      dispatch(hotelSearch(payload));
    }
    track('hotelsFilter.handleChange', {
      filterHotelKeys: JSON.stringify(newValue),
    });
  };

  /* TODO: this is repeating twice - here and in amenities.
  maybe it should have lived in the saga after all?  */
  /*
    Removed that logic from the hotel.js saga.
    Side effect that needed to prepare data to
    the TwAutocomplete component located in the MultiSelectAutocompleteFilter.
  */
  useEffect(() => {
    if (searchStateHotelNames) {
      setHotels([
        {
          suggests: sortBy(
            searchStateHotelNames.map(({ name, hotelKey }) => ({
              value: hotelKey,
              label: name,
            })),
            ['label'],
          ),
          label: 'Hotel name',
          value: 'hotelName',
        },
      ]);
    }
  }, [searchStateHotelNames]);

  return searchStateHotelNames && searchStateHotelNames.length > 0 ? (
    <MultiSelectAutocompleteFilter
      onChange={handleChange}
      label="Hotel Name"
      options={hotels}
      values={value}
      filterMaxWidthClass="max-w-full"
      variant={variant}
      filterSpacingClass={filterSpacingClass}
      bgClassName={!isHotelTripSearch ? '' : undefined}
      freeSolo={false}
      openOnFocus
    />
  ) : (
    <></>
  );
};

HotelNameFilter.propTypes = {
  tripId: PropTypes.string,
  variant: PropTypes.string,
  filterSpacingClass: PropTypes.string,
};

HotelNameFilter.defaultProps = {
  tripId: undefined,
  variant: 'outline',
  filterSpacingClass: undefined,
};
export default HotelNameFilter;
